const companyAddressType = [{
  key: 'pages_company_addressType_001',
  value: '0'
},
{
  key: 'pages_company_addressType_002',
  value: '1'
},
{
  key: 'pages_company_addressType_003',
  value: '2'
}]

export default companyAddressType
